export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/837e258702481769ad64684ae735d0c9.svg";